import React from 'react'
import EditTenantParam from "../actions/EditTenantParam"
import _checkRoles from "../../../../helpers/checkRole";

const TenantTableItem = (props) => {
    const {index, item} = props

    return (
        <tr className="RowItem SettingTeantDealerItem">
            <td className="No">{index + 1}</td>
            <td className="ParentName">{item.parentName}</td>
            <td className="TenantName">{item.tenantName}</td>
            <td className="License">{item.license}</td>
            <td className="ExtUsed">{item.extUsed}</td>
            <td className="Actions text-center">
                <EditTenantParam tenantId={item.tenantId} type='view'/>
            </td>
            <td className="Actions text-center">
                {
                    _checkRoles('menu.setting.tenantDealer.updateTenant') &&
                    <EditTenantParam tenantId={item.tenantId} type='edit'/>
                }
            </td>
        </tr>
    )
}

export default TenantTableItem